import React from 'react';

const locationHost = window.location.host;
let hostText = 'Freeview';
let linkText = '/get-freeview';

if (locationHost.indexOf('freely') > -1) {
  hostText = 'Freely';
  linkText = '/get-freely';
}

const Ads = () => (
  <div className="fv-search-app__ads">
    <h3>
      The biggest shows live and on demand, all in one place and all for free
      with {`${hostText}`} Play
    </h3>
    <a href={`${linkText}`} className="fv-button fv-button--secondary">
      Get {`${hostText}`} Play
    </a>
  </div>
);

export default Ads;
